export const SET_STEP = 'SET_STEP';
export const RECEIVE_STEP = 'RECEIVE_STEP';
export const SET_BAR_STATE = 'SET_BAR_STATE';

export function setStep(path) {
  return {
    type: SET_STEP,
    path,
  };
}

export function receiveStep(stepObj) {
  return {
    type: RECEIVE_STEP,
    step: stepObj.step,
    path: stepObj.path,
  };
}

export function setBarBackOpen(bool) {
  return {
    type: SET_BAR_STATE,
    state: bool,
  };
}
